import Vue from 'vue';
import Component from 'vue-class-component';
// import { Watch } from 'vue-property-decorator';
import {_MEETINGS_STORE, MEETING_EVENTS, MEETING_TYPES_IDS, EDUPAD_COLLECTIONS} from '@/meetings/values/meetings.values';
// import * as PRESENTATION_VALUES from '@/content/values/ed-presentation-mode.values';
import KEYS from '@/values/keys';
import { _HOMEWORKS_STORE } from '@/homework/values/homeworks.values';
import { CORE_ROUTES } from '@/core/core.router';
import {CLOSE_BOARD_SOCKET_DISCONNECTING_EVENT, SHOW_SOCKET_DISCONNECTING_EVENT} from '@/core/values/app.values';
import {POPUP_MENU_EVENTS} from '@/values/general.values';
import {CLOSE_NAV_MEETING_TOOLS_EVENT, PRESENTATION_MODE_EVENTS} from '@/content/values/ed-presentation-mode.values';
import EdBlankWhiteboard from '@/components/common/ed-blank-whiteboard/ed-blank-whiteboard.vue';
import EdEdupadEditor from '@/components/common/ed-edupad/ed-edupad-editor/ed-edupad-editor.vue';

@Component({
    components: {
        EdPresentationModeWebviewOptions: () => import(/* EdPresentationModeWebviewOptions */'../ed-presentation-mode/ed-presentation-mode-webview-options/ed-presentation-mode-webview-options.component.vue'),
        EdBlankWhiteboard,
        EdEdupadEditor
    }
})
export default class EdMeetingContainer extends Vue {

    private iframeContent    : string = 'contentWindow';
    private registryWboEvent : string = 'Registry';
    private messageEvent     : string = 'message';
    private hostTeacherLeft  : boolean = false;
    public edupadKey         : number = 0;
    

    get pageSource() : string {  
      let pageSource: string = this.$store.state.MeetingsStore.meetingPage;
      if(this.isWebView) {
        const letter = pageSource.includes('?') ? '&' : '?'; 
        return `${pageSource}${letter}showTitle=false`;
      }             
      return pageSource;
    }

    get firstName() : string {
        return this.$store.state.AuthStore.user.firstName;
    }

    get isPublisher() : boolean {
      return this.$store.state.AuthStore.role === KEYS.ROLES.PUBLISHER;
    }

    get currentMeetingData() {
      return this.$store.state.MeetingsStore.currentMeetingData;
    }
  
    get isWhiteBoard(): boolean {
      return this.currentMeetingData.meetingType === MEETING_TYPES_IDS.WHITEBOARD
    }
    get isSharedDoc(): boolean {
      return this.currentMeetingData.meetingType === MEETING_TYPES_IDS.SHARED_DOC
    }
    get isSheet(): boolean {
      return this.currentMeetingData.meetingType === MEETING_TYPES_IDS.SHEET
    }
    get isSlide(): boolean {
      return this.currentMeetingData.meetingType === MEETING_TYPES_IDS.SLIDE
    }

    get isStudentToggle() : boolean {
      return this.currentMeetingData.studentToggle;
    } 

    get collection() : string {
      return EDUPAD_COLLECTIONS.MEETINGS;
    }

    get params() {
      return this.$route.params;
    }

    get presentationModeMeetings(): number[] {
      return this.$store.state.MeetingsStore.presentationModeMeetings;
    }
  
    get existsMeeting(): boolean {
      return this.presentationModeMeetings.includes(this.currentMeetingData.meetingId);
    }

    get isBoardPreviousDisconnectionSocket() : boolean {
      return this.$store.state.AppStore.isBoardPreviousDisconnectionSocket;
    }

    get isPresentationModeGuestTeacher() : boolean {
      return this.$store.state.MeetingsStore.isPresentationModeGuestTeacher;
    }

    get isWebView() {
      return this.$store.state.AppStore.webview && this.isPublisher;
    }
    
    get srcLogo() {
      const types = [-2,-3,-5,-6];
      if(types.includes(this.currentMeetingData.meetingType)) {
        return `type${this.currentMeetingData.meetingType}`;
      } else {
        return null;
      }
    }

    get meetingSessionId(): string {
        return this.$store.state.MeetingsStore.meetingSessionId;
    }

    get edupacDocumentId(): string {
      return this.$store.state.MeetingsStore.edupadDocumentId;
    }

    get edupacCollection(): string {
      return this.$store.state.MeetingsStore.edupacCollection;
    }

    get isStudent(): boolean {
        return !this.isPublisher && !this.isPresentationModeGuestTeacher;
    }

    get isReadOnlyStudent(): boolean {
        return this.isStudent && this.isStudentToggle;
    }

    get isWhiteBoardActive(): boolean {
        const isWhiteBoardActive = this.isWhiteBoard && Boolean(this.meetingSessionId);
        if (this.isStudent) {
            return isWhiteBoardActive && this.existsMeeting;
        }
        if (this.isPresentationModeGuestTeacher) {
            return isWhiteBoardActive && !this.hostTeacherLeft;
        } else {
            return isWhiteBoardActive;
        }
    }

    get isSharedDocActive(): boolean {
      return this.isSharedDoc && !this.hostTeacherLeft;
    }

    public closeContextMenu = () => {
      this.$edEventBus.$emit(POPUP_MENU_EVENTS.CLOSE_POPUP_MENU);
      this.$edEventBus.$emit(CLOSE_NAV_MEETING_TOOLS_EVENT);
      this.$EdContextMenu.close();
    }

    public updateDocumentUsername() : void {
      window.addEventListener(this.messageEvent, this.manageMessageEvents);
    }

    private leaveTeacherPresentation(){
        this.hostTeacherLeft = true;
      if (!this.existsMeeting) {
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.CLEAN_MEETING_PAGE);
      }
    }

    private manageMessageEvents(msg : any) : void {
      var dataObject = typeof(msg.data) === 'string' ? JSON.parse(msg.data) : msg.data;

      if(dataObject.data == '_EDUAC_READY' && this.$refs.iframeRef[this.iframeContent]) {
        this.$refs.iframeRef[this.iframeContent].postMessage(JSON.stringify({ eduacUsername: this.firstName }), '*');
      }

      if(dataObject.data == '_EDUAC_NEWDOC') {
        let params = {
          type: dataObject.type,
          meetingId: parseInt(this.params.meetingId)
        }
        this.$edEventBus.$emit(MEETING_EVENTS.UPDATE_DOCUMENT_URL, params);
      }

      if(dataObject.data == '_EDUAC_COURSEVIEWER') {
        const path = CORE_ROUTES.JOIN_MEETING.PATH
          .replace(':classId', this.params.classId)
          .replace(':id', '-4')
          .replace(':meetingId', this.params.meetingId);
        const courseViewer = `${window.location.protocol}//${window.location.host}${path}`;
        this.$refs.iframeRef[this.iframeContent].postMessage(JSON.stringify({ courseViewerUrl: courseViewer}), '*');
      }
    }

    private manageTransparencyDisconnectMessage(isDisconnected : boolean) : void {
      if(isDisconnected){
        this.$edEventBus.$emit(SHOW_SOCKET_DISCONNECTING_EVENT, {isBoard: true});
      } else if(!isDisconnected && this.isBoardPreviousDisconnectionSocket){
        this.$edEventBus.$emit(CLOSE_BOARD_SOCKET_DISCONNECTING_EVENT);
      }
    }

    public refreshEdupad(){
      this.edupadKey += 1;  
    }

    public deleteDocument(){
        this.$EdModal.createMessageModal({
          title: this.$t('edupad.docDeletedTitle'),
          body: this.$t('edupad.docDeleted'),
          type: KEYS.EVENT_TYPES.WARNING,
          action: () =>  this.refreshEdupad()
        });
    }

    created() {
        if (!this.isWhiteBoard) {
            const iframe = (document?.querySelector('#pdf-content') as HTMLIFrameElement);
            if (iframe) {
                iframe.contentWindow.addEventListener('click', this.closeContextMenu);
            }
        }
    }

    mounted() {
        this.$edEventBus.$on(PRESENTATION_MODE_EVENTS.LEAVE_TEACHER_EVENT, this.leaveTeacherPresentation);
        this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.SET_EDUPAD_ACTIVE, true); //Disable disconected modal
    }

    beforeDestroy(){
        this.$edEventBus.$off(PRESENTATION_MODE_EVENTS.LEAVE_TEACHER_EVENT, this.leaveTeacherPresentation);
        window.removeEventListener(this.messageEvent, this.manageMessageEvents);
        this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.SET_EDUPAD_ACTIVE, false); //Enable disconected modal
    }

    updated() {
        window.addEventListener('blur',  this.closeContextMenu);
    }
}